export default "__VITE_ASSET__Bit0LV8b__"